// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"7587d817","515":"9cc0ef36","773":"2cb9fa66"}[chunkId] + ".chunk.css";
};